import type {PageRouteConfig} from '@router';

import CouponList from 'modules/Services/PromotionCenter/Coupon/List/CouponList';
import {routes} from 'routes/routes';

export function createPromotionCenterCouponListRoute(): PageRouteConfig {
  return {
    element: <CouponList />,
    layout: {
      title: 'کوپن',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.PROMOTION_CENTER
    }
  };
}
